<template>
    <div class="service-header tw-grid tw-items-start">
        <!-- Artwork -->
        <div class="service-header__artwork tw-rounded tw-overflow-hidden tw-self-start">
            <BaseArtwork :src="beatTape.image(300)"
                :image-size="300" active-transparent>
            </BaseArtwork>
        </div>

        <!-- Details -->
        <div class="service-header__details">
            <!-- Title -->
            <div class="tw-text-3xl tw-font-medium tw-text-infinity-primary-text tw-flex tw-items-center tw-mb-5">
                <span>{{ beatTape.title }}</span>
                <share-button :item="beatTape" class="tw-text-infinity-tertiary-text tw-ml-4"
                              style="font-size: 1.15rem;" />
            </div>
            <div v-show="itemsCount" class="tw-mb-6"><i class="fa fa-waveform-path tw-mr-2"></i>{{ itemsCount }}</div>

            <div class="service-header__buy">
                <buy-button class="tw-mb-6" :label="buyButtonLabel" variant="boxed-big" :item="beatTape"  />
            </div>

        </div>

    </div>
</template>
<script>
import BaseArtwork from "../../base/base-artwork";
import BasePlay from "../../base/base-play";
import BeatTapes from "../../../models/beat-tapes";
import ShareButton from "../../shared/share-button";
import BeatTapeHeaderDescription from "./beat-tape-header-description";
import BuyButton from "../../shared/buy-button";

export default {
    components: {
        BuyButton,
        BeatTapeHeaderDescription,
        ShareButton, BasePlay, BaseArtwork
    },
    props: {
        beatTape: {
            type: BeatTapes
        }
    },
    computed: {
        buyButtonLabel() {
            return `Buy Beat Tape $${this.beatTape.price}`
        },
        itemsCount() {
            if (!this.beatTape.itemsCount) return
            return this.beatTape.itemsCount + " Beats"
        }
    }
};
</script>
<style lang="scss" scoped>
.service-header {
    @apply tw-gap-7;
    grid-template-columns: 1fr;
    grid-template-areas: 'artwork' 'details' 'chips' 'buy';

    &__artwork {
        grid-area: artwork;
    }

    &__details {
        grid-area: details;
    }

    &__chips {
        grid-area: chips;
    }

    &__video {
        grid-area: video;
    }

    &__buy {
        grid-area: buy;
    }

    @screen sm {
        grid-template-columns: minmax(20%, 150px) 1fr;
        grid-template-areas: 'artwork details' 'chips chips' 'buy buy';
    }

    @screen md {
        grid-template-areas: 'artwork details' 'artwork chips' 'artwork buy';
    }

    @screen lg {
        grid-template-columns: minmax(20%, 200px) 1fr;
        grid-template-rows: auto 1fr auto;
    }
}
</style>
